<template>
  <b-field
    :label="label"
    :message="msgError"
    :type="msgError ? 'is-warning' : ''">
    <b-autocomplete
      :value="search"
      :data="itemsFiltered"
      :loading="isFetching"
      :open-on-focus="openOnFocus"
      :disabled="disabled"
      :expanded="expanded"
      @input="getItems"
      @select="setItem"
      @click.native="$emit('click-autocomplete', $event)"
      ref="produitAutocomplete"
      field="codeLibelle"
      icon="magnify">
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <template v-for="(_, name) in $scopedSlots" v-slot:[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
      <template slot="empty">
        <div v-if="!isFetching">
          {{$t('general.autocomplete.noRslt')}}
        </div>
        <div v-else>
          {{$t('general.autocomplete.search')}}
        </div>
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
import debounce from 'lodash/debounce';
import { getAll as getAllProduits } from '@/api/produit/index';
import messageErreur from '@/services/general/messageErreur';
import { RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';

export default {
  name: 'ProduitAutocomplete',
  props: {
    label: {
      type: String,
      required: false,
    },
    value: {
      type: Object,
      required: false,
    },
    societeActiveId: {
      required: true,
    },
    sens: {
      type: String,
      required: true,
    },
    categories: {
      type: Array,
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    filteredItemFunc: {
      type: Function,
      required: false,
    },
    openOnFocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
    msgError: {
      type: String,
      required: false,
    },
    focus: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      search: null,
      isFetching: false,
    };
  },
  computed: {
    itemSelected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    itemsFiltered() {
      return this.items
        .filter(el => !this.filteredItemFunc || this.filteredItemFunc(el));
    },
  },
  methods: {
    getType(code) {
      return CATEGORIE_PRODUIT.find(p => p.code === code)?.libelle ?? '';
    },
    async getProduits(text) {
      this.isFetching = true;
      try {
        const dataItems = (await getAllProduits({
          query: {
            auto: text,
            actif: true,
            sens: this.sens,
            categorie: this.categories,
            societeId: this.societeActiveId,
          },
          limit: RESULTS_PER_PAGE,
        })).data.result.items;
        dataItems.map((el) => {
          el.codeLibelle = [
            this.categories.length
              ? this.$t(this.getType(el.supportCommercial.categorieVente))
              : '',
            el.reference,
            el.libelle,
          ].filter(Boolean).join(' - ');
          return el;
        });
        this.items = dataItems;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetching = false;
      }
    },
    getItems: debounce(async function itemsData(text) {
      if (text === this.search) return;
      this.search = text;
      this.itemSelected = null;
      await this.getProduits(text);
    }, 500),
    setItem(val) {
      if (!val) return;
      this.search = val.libelle;
      this.itemSelected = val;
    },
  },
  async mounted() {
    this.search = this.value?.libelle;
    if (this.openOnFocus) await this.getProduits();
    if (this.focus) this.$refs.produitAutocomplete?.focus();
  },
};
</script>
